import { useEffect, useMemo, useState } from 'react'
import { isDesktop } from '../../../client'
import { Container } from './Ozen.styles'
import { AdId, usePageMeta } from '../../../contexts'
import Ad, { SizeMap } from '../../../sharedComponents/Ads/Ad'

type IOzenProps = {
  side: 'left' | 'right'
}

const sizeMap: SizeMap = [
  {
    screen: [1610, 0],
    ad: [120, 600],
  },
  {
    screen: [1690, 0],
    ad: [160, 600],
  },
  {
    screen: [1970, 0],
    ad: [300, 600],
  },
]
export const Ozen = ({ side }: IOzenProps) => {
  const PageMeta = usePageMeta()
  const [shouldRender, setShouldRender] = useState(false)
  const [filteredSizeMap, setFilteredSizeMap] = useState<SizeMap | null>(null)
  const id = useMemo(() => `Ozen_${side}` as AdId, [side])

  useEffect(() => {
    // Only render on desktop
    setShouldRender(isDesktop())
  }, [])

  useEffect(() => {
    const hasWarComp = !!PageMeta?.war_comp?.showWarRail
    const w = (window.innerWidth - 1290) / 2
    let tempSizeMap = sizeMap.filter(t => t.ad[0] <= w)
    if (hasWarComp) {
      tempSizeMap = tempSizeMap.filter(t => t.ad[0] < 300)
    }
    setFilteredSizeMap(tempSizeMap)
  }, [PageMeta?.war_comp])

  if (!shouldRender || !side || !filteredSizeMap || !id) {
    return null
  }

  return (
    <Container side={side}>
      <Ad id={id} sizeMap={filteredSizeMap} />
    </Container>
  )
}
